"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _stylingUtils = require("../../services/stylingUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var iconsWithNoPadding = ['user', 'download', 'not connected', 'not favourite', 'not shared favourite', 'expand', 'search-2', 'consignment', 'airplane', 'exclamation', 'cross', 'tick', 'lss dips level 1', 'lss dips level 2', 'lss dips level 3', 'lss dips level 4', 'lss checking', 'lss consignments', 'lss declaration', 'flight', 'organic', 'payment', 'animals', 'fish', 'other', 'vegetables', 'lss importer risk', 'lss product risk'];

var RheIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(RheIcon, _React$Component);

  var _super = _createSuper(RheIcon);

  function RheIcon() {
    _classCallCheck(this, RheIcon);

    return _super.apply(this, arguments);
  }

  _createClass(RheIcon, [{
    key: "_getClassNames",
    value: function _getClassNames() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        "rhe-icon--arrow-up": this.props.icon === "arrow up",
        "rhe-icon--blog": this.props.icon === "blog",
        "rhe-icon--discussion": this.props.icon === "discussion",
        "rhe-icon--folder": this.props.icon === "folder",
        "rhe-icon--link": this.props.icon === "link",
        "rhe-icon--suite": this.props.icon === "suite",
        "rhe-icon--user": this.props.icon === "user",
        "rhe-icon--no-padding": document.documentMode ? iconsWithNoPadding.indexOf(this.props.icon) >= 0 : iconsWithNoPadding.includes(this.props.icon)
      });
    }
  }, {
    key: "_iconSelect",
    value: function _iconSelect(icon) {
      icon = icon.toLowerCase();

      switch (icon) {
        case "arrow up":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/arrow_up--small.png";

        case "bell":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/notification--small.png";

        case "blog":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/blog--small.png";

        case "cross":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2033_RIAMS_icon_cross_cropped--small.png";

        case "decision":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/decision--small.png";

        case "discussion":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/discussion--small.png";

        case "new document":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/RIAMS_icon_document-small.png";

        case "updated document":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/RIAMS_icon_document_update-small.png";

        case "favourite document":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/RIAMS_icon_document_favourite-small.png";

        case "document with star":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_document_favourite--small.png";

        case "exclamation":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2033_RIAMS_icon_exclamation_cropped--small.png";

        case "reviewed document":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/RIAMS_icon_document_review-small.png";

        case "folder":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/folder--small.png";

        case "hamburger":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1901_icon_hamburger_white.png";

        case "link":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/link.png";

        case "message":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/message--small.png";

        case "search":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/search--small.png";

        case "search-2":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2046_icon_PH_search.png";

        case "consignment":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2046_icon_PH_consignment.png";

        case "airplane":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2046_icon_PH_air_waybill.png";

        case "settings":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/settings--small.png";

        case "shared":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/connect-green.png";

        case "not shared":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/connect-green-transparent.png";

        case "suite":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/riams_suite.png";

        case "support":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/RIAMS_icon_support-small.png";

        case "tag":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/tags--small.png";

        case "tick":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2033_RIAMS_icon_tick_cropped--small.png";

        case "trash":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/trash.png";

        case "user":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2046_icon_user_white.png";

        case "not favourite":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_favourite-coloured.png";

        case "favourite":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_favourite.png";

        case "download":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_download-coloured.png";

        case "download disabled":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_download-grey.png";

        case "feedback":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_feedback-coloured.png";

        case "more coloured":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_more-coloured.png";

        case "more":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_more.png";

        case "not connected":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_connect-coloured.png";

        case "connected":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_connect.png";

        case "shared favourite":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_favourite_shared.png";

        case "not shared favourite":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_favourite_shared-coloured.png";

        case "expand":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2046_icon_expand_blue_square.png";

        case "upload":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_upload--coloured.png";

        case "lss dips level 1":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_DIPS_level_1_12.png";

        case "lss dips level 2":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_DIPS_level_2_12.png";

        case "lss dips level 3":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_DIPS_level_3_12.png";

        case "lss dips level 4":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_DIPS_level_4_12.png";

        case "lss checking":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_checking_04.png";

        case "lss consignments":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_consignments_12.png";

        case "lss declaration":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_declaration_12.png";

        case "flight":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_flight_12.png";

        case "organic":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_organic_12.png";

        case "payment":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_payment_12.png";

        case "animals":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_product_animal_12.png";

        case "fish":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_product_fish_12.png";

        case "other":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_product_other_12.png";

        case "vegetables":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/2072_icon_product_vegetable_12.png";

        case "lss importer risk":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_risk_importer_12.png";

        case "lss product risk":
          return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/port-health/live-status-screen/2072_icon_risk_product_12.png";

        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: this._getClassNames(),
        onClick: this.props.onClick,
        backgroundColour: this.props.backgroundColour,
        src: this._iconSelect(this.props.icon),
        altText: this.props.altText
      });
    }
  }]);

  return RheIcon;
}(_react["default"].Component);

exports["default"] = RheIcon;
RheIcon.defaultProps = {
  onClick: function onClick() {}
};
RheIcon.propTypes = {
  altText: _propTypes["default"].string,
  backgroundColour: _propTypes["default"].string,
  icon: _propTypes["default"].string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/pattern-library/dist/js/components/RheIcon/index.js
// module id = 1400
// module chunks = 0